export default {
  unrestricted: 'Sin restricción',
  lessThan: 'Menor que',
  moreThan: 'Mayor que',
  between: 'Entre',
  exactly: 'Exactamente',
  mustBeLarger: 'Debe ser mayor'
}
